import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import { checkPixelCollision } from '../ndgmr.Collision-phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class KeychainChain extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, weightSprite, collisionSprite)
    {
        super(scene);

        this.collisionSprite = collisionSprite;

        this.delegate = null;

        this.gravity = 48;
        this.friction = 0.82;
        this.spring = 0.76;
        this.joins = 8;
        this.distance = 0.20;

        this.rope = null;

        this.px = [];
        this.py = [];
        this.oldx = [];
        this.oldy = [];
        this.ax = [];
        this.ay = [];

        this.createRope(x, y);
        this.add(this.rope);

        this.handle = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_ChainHoop, this).setOrigin(0.5, 1).setInteractive({ draggable: true }).disableInteractive();
        this.handle.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startDrag, this);
        this.handle.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.doDrag, this);
        this.handle.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.stopDrag, this);

        this.weight = ABCyaPhaser.Images.addImage(weightSprite.x, weightSprite.y, weightSprite.frame.name, this).setOrigin(0.5, 0.5 * 0.25);
        this.weight.y += this.weight.height;

        this.handle.x = 222;
        this.handle.y = 222;

        this.lastPos = { x: 0, y: 0 };
        this.prevPos = { x: 0, y: 0 };
    }

    enableDrag()
    {
        this.handle.setInteractive();
    }

    createRope(x, y)
    {
        this.rope = this.scene.add.graphics();
        for (var i = 0; i < this.joins; i++)
        {
            this.px.push(x);
            this.py.push(y);
            this.oldx.push(x);
            this.oldy.push(y);
            this.ax.push(0);
            this.ay.push(0);
        }
    }

    startDrag(pointer)
    {
        this.scene.input.once(Phaser.Input.Events.POINTER_UP, () => this.stopDrag());
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._keychain, this.scene);
        this.handle.dragOffsetX = this.handle.x - pointer.x;
        this.handle.dragOffsetY = this.handle.y - pointer.y;
    }

    doDrag(pointer, x, y)
    {
        this.handle.setPosition(x, y);
    }

    stopDrag()
    {
        this.scene.input.off(Phaser.Input.Events.POINTER_UP);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._keychain, this.scene);

        let col = checkPixelCollision(this.handle, this.collisionSprite, 0);
        if (!col)
        {
            this.handle.removeAllListeners();
            if (this.delegate) this.delegate.removeKeychainItem(this);
        }
    }

    updatePos(x, y)
    {
        this.handle.x = x;
        this.handle.y = y;
    }

    tick(dt)
    {
        let x = this.handle.x;
        let y = this.handle.y;

        this.applyForces(dt);
        this.applyFriction();
        this.applyTension();

        this.px[0] = x;
        this.py[0] = y;

        this.rope.clear();
        this.rope.lineStyle(2, 0xC8C9CC);
        this.rope.moveTo(this.px[0], this.py[0]);
        
        for (let i = 0; i < this.joins; i++)
        {
            this.rope.lineTo(this.px[i], this.py[i]);

            if (i > 0)
            {
                this.prevPos.x = this.px[i - 1];
                this.prevPos.y = this.py[i - 1];
            }
            this.lastPos.x = this.px[i];
            this.lastPos.y = this.py[i];
        }
        this.rope.stroke();

        this.weight.angle = (angleBetweenPoints(this.prevPos, this.lastPos) * Phaser.Math.RAD_TO_DEG) +90;
        this.weight.x = this.lastPos.x;
        this.weight.y = this.lastPos.y;
    }

    applyForces(d)
    {
        for (let i = 1; i < this.joins; i++)
        {
            this.py[i] += (this.gravity * d);
        }
    }

    applyFriction()
    {
        for (let i = 1; i < this.joins; i++)
        {
            let prevx = this.px[i];
            let prevy = this.py[i];

            this.px[i] += (this.px[i] - this.oldx[i]) * this.friction;
            this.py[i] += (this.py[i] - this.oldy[i]) * this.spring;

            this.oldx[i] = prevx;
            this.oldy[i] = prevy;
        }
    }

    applyTension()
    {
        let joinDistance = this.distance / this.joins;
        let dx = 0, dy = 0, d = 0, force = 0;
        for (let i = 1; i < this.joins; i++)
        {
            dx = (this.px[i] - this.px[i - 1]) / 100;
            dy = (this.py[i] - this.py[i - 1]) / 100;
            d = Math.sqrt((dx * dx) + (dy * dy));
            force = d - joinDistance;
            this.ax[i] = (dx / d) * 0.5 * 100 * force;
            this.ay[i] = (dy / d) * 0.5 * 100 * force;
            this.px[i] -= this.ax[i];
            this.py[i] -= this.ay[i];
            this.px[i - 1] += this.ax[i];
            this.py[i - 1] += this.ay[i];
        }
    }
}

function angleBetweenPoints(p1, p2) {
    let dx = p1.x - p2.x;
    let dy = p1.y - p2.y;
    let radians = Math.atan2(dy, dx);
    return radians;
}